export const PROTOCOL_VERSION = 1;
//# sourceMappingURL=version.js.map